var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoTrainlineIcon = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 21, viewBox: "0 0 24 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.4574 2.33283C15.8661 -0.110943 19.7851 -0.110943 22.1936 2.33283C24.6021 4.77668 24.6021 8.75315 22.1936 11.197L13.7487 19.7657C12.7837 20.7448 11.2192 20.7447 10.2542 19.7657L20.4464 9.42418C21.1464 8.71389 21.532 7.76948 21.532 6.76492C21.532 5.76035 21.1464 4.81595 20.4464 4.10565C19.0013 2.63937 16.6498 2.63937 15.2047 4.10565L8.50702 10.9015L5.30373 7.65128C4.82128 7.16177 4.82128 6.36807 5.30373 5.87847C5.78626 5.38895 6.5685 5.38895 7.05103 5.87847L8.50702 7.3558L13.4574 2.33283ZM16.9519 5.87847C17.4344 5.38896 18.2167 5.38896 18.6992 5.87847C19.1816 6.36799 19.1816 7.16177 18.6992 7.65129L8.50701 17.9928L1.8093 11.197C0.642597 10.0131 0 8.43914 0 6.76492C0 5.09071 0.642597 3.51664 1.8093 2.33284C4.12004 -0.0116819 7.82059 -0.106546 10.2443 2.04743L8.49075 3.82667C7.03684 2.64645 4.90323 2.7392 3.55651 4.10566C2.11141 5.57194 2.11141 7.95783 3.55651 9.42419L8.50701 14.4472L16.9519 5.87847Z", fill: "#00A88F" }))),
        alt: 'Trainline',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoTrainlineIcon;
//# sourceMappingURL=index.js.map